import { IRawStudentExportData } from '../../types/types';

import { graphQLPost } from '../../utilities';

export default class RawDataExport {
    static async getRawStudentExport(): Promise<IRawStudentExportData[]> {
        try {
            const response = await graphQLPost(`{
                rawStudentExport {
                    studentFirstName,
                    studentLastName,
                    studentSSN,
                    studentGender,
                    className,
                    studentProgram,
                    schoolUnitCode,
                    schoolUnitName,
                    unitCode,
                    unitName,
            
                    courseName,
                    courseDisplayName,
                    courseInstanceEndDate,
                    courseInstanceStartDate,
                    courseTypeName,
            
                    groupName,
            
                    studentPrognosis,
                    studentGrade,
                    studentPoints
                  }
              }`);
            
            return response.rawStudentExport as IRawStudentExportData[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av rådata...");
        }
    }
    
    static async getRawStudentExportHist(from: Date, to: Date): Promise<IRawStudentExportData[]> {
        try {
            const response = await graphQLPost(`
                query GetRawStudentExportHistory($from: DateTime, $to: DateTime) {
                    rawStudentExportHistorical(from: $from, to: $to) {
                        studentFirstName,
                            studentLastName,
                        studentSSN,
                        studentGender,
                        className,
                        studentProgram,
                        schoolUnitCode,
                        schoolUnitName,
                        unitCode,
                        unitName,
                
                        courseName,
                        courseDisplayName,
                        courseInstanceEndDate,
                        courseInstanceStartDate,
                        courseTypeName,
                
                        groupName,
                
                        studentPrognosis,
                        studentGrade,
                        studentPoints
                    } 
                }`,
                { from: from.toDateString(), to: to.toDateString() });
            
            return response.rawStudentExportHistorical as IRawStudentExportData[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av rådata...");
        }
    }
}